import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { logEventGA4 } from '../../google';
import { migrateReduxSessionStorageFilterValue, sessionStorageMF } from '../../utils';
import { setFilterValue } from '../filterValue';

const initialState = {
  display: 'Doctor Name',
  name: 'doctorName',
  type: 'input',
  selected: '',
};
const storeName = 'doctorName';
export const useDoctorNameFilter = create(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        set,
        reset: () => set({ ...initialState }, false, { type: 'reset' }),
        getInitialState: () => ({ ...initialState }),
        setFilterValue: (v) => updateDoctorNameFilterOption(v),
      }),
      {
        name: `${process.env.NX_APP}-${storeName}`,
        version: 0,
        storage: createJSONStorage(() => sessionStorageMF),
        onRehydrateStorage: () => (state) => {
          migrateReduxSessionStorageFilterValue({ state, key: 'doctorName' });
        },
      },
    ),
    {
      name: `${process.env.NX_APP}`,
      store: storeName,
    },
  ),
);

export const updateDoctorNameFilterOption = (option) => {
  if (option && process.env.NX_APP === 'MediFind-Pro') {
    logEventGA4('filter', { type: 'doctor_name', action: 'select', item_id: option }, '1e92ce09-41c4-40d8-a9c6-79fac1a7d2de');
  }
  setFilterValue(useDoctorNameFilter, option);
};
export const clearDoctorNameFilterOption = () =>
  useDoctorNameFilter.setState(initialState, false, {
    type: 'clearDoctorNameFilterOption',
  });
